<script setup lang="ts">
import { computed } from 'vue';
import { BIcon } from '@/design-system';
import { useTranslation } from '@/composables';

type PropsType = {
    icon?: string;
    title?: string;
    description?: string;
    iconSize?: string | number;
    iconColor?: string;
    minHeight?: number;
};

const props = withDefaults(defineProps<PropsType>(), {
    icon: 'mdi-chart-line',
    title: '',
    description: '',
    iconSize: '64',
    iconColor: 'grey',
    minHeight: 300,
});

const { t } = useTranslation();

const displayTitle = computed(() => props.title || t('statistics.charts.noData.title'));

const displayDescription = computed(() => props.description || t('statistics.charts.noData.description'));

const containerStyle = computed(() => ({ minHeight: `${props.minHeight}px` }));
</script>

<template>
    <div
        class="b-chart-empty-state"
        :style="containerStyle"
    >
        <div class="text-center pa-8">
            <BIcon
                :icon="props.icon"
                :size="props.iconSize"
                :color="props.iconColor"
                class="mb-4"
            />
            <h3 class="text-h6 text-grey mb-2">
                {{ displayTitle }}
            </h3>
            <p class="text-body-2 text-grey">
                {{ displayDescription }}
            </p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.b-chart-empty-state {
    border: 2px dashed rgb(var(--v-theme-on-surface));
    border-radius: 8px;
    opacity: 0.5;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
